import { generatePath } from 'react-router-dom';

import * as ROUTES from '#client/constants/routes';

import { processMenu } from '../utils/menu';

/**
 * Get the insights menu.
 *
 * @param {{
 *  businessEntityUuid: string
 *  order: number
 * }} params
 * @returns {object}
 */
export function getInsightsMenu({ businessEntityUuid, order }) {
  return processMenu({
    title: 'Zen Labs',
    itemId: 'zenlabs',
    icon: 'insights-nav-icon.svg',
    path: generatePath(ROUTES.entityZenlabs, { businessEntityUuid }),
    isBeta: true,
    order
  });
}
